import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseApi, BASE_URL, User } from '@edl-development/edl-common';
import { PermissionNode } from '../../model/permissions/permission-node.model';
import { PAETEPRoleType } from '../../model/enum/paetep-role-types.enum';
import { EditRolePermissionsDTO } from 'src/app/model/permissions/edit-role-permissions-dto.model';
import { BuildingToRolePermission } from 'src/app/model/permissions/building-to-role-permission-dto.model';

@Injectable()
export class PermissionsApi extends BaseApi {

    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getMyPermissions() {
        return this.http.get<string[]>(this.baseUri + '/Permissions/GetMyPermissions', {});
    }

    getRolesICanManage() {
        return this.http.get<PAETEPRoleType[]>(this.baseUri + '/Permissions/GetRolesICanManage', {});
    }

    getRolesICanManagePerBuilding() {
        return this.http.get<BuildingToRolePermission>(this.baseUri + '/Permissions/GetRolesICanManagePerBuilding', {});
    }

    getPermissions(roleIds?: PAETEPRoleType[], portalId?: number) {
        let params = new HttpParams();

        roleIds?.forEach(r => {
            params = params.append('roleIds', r)
        });

        if (portalId != null && portalId != undefined) {
            params = params.set('portalId', portalId);
        }

        return this.http.get<PermissionNode[]>(this.baseUri + '/Permissions/GetPermissions', { params });
    }

    updateRolePermissions(editRolePermissionsDTO: EditRolePermissionsDTO) {
        return this.http.post<PermissionNode[]>(this.baseUri + '/Permissions/UpdateRolePermissions', editRolePermissionsDTO);
    }
}